<script setup lang="ts">
import { ref, computed } from 'vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'

const props = defineProps<{
  cmsDataPath: (string | number)[]
  dataLength: number
  data: CmsCustomComponentType[]
}>()

const currentShowNumber = ref<number>(2)

const shownAktualnosci = computed(() => {
  return props.data.slice(0, currentShowNumber.value)
})

const dataRow = computed(() => {
  const items = shownAktualnosci.value
  const rows = []

  for (let i = 0; i < items.length; i += 1) {
    rows.push(items.slice(i, i + 1))
  }

  return rows
})

const ShowMore = () => {
  if (currentShowNumber.value >= props.dataLength) return
  currentShowNumber.value += 1
}
</script>

<template>
  <div class="flex flex-col gap-6 xl:gap-12 w-full">
    <div
      v-for="(item, i) in dataRow"
      :key="JSON.stringify(item)"
      class="flex flex-col gap-6 xl:gap-12 w-full"
    >
      <CmsImage
        :cms-data-path="[...props.cmsDataPath, i, 'image_1']"
        class="rounded-3xl max-h-180 w-full object-cover"
      />
      <div class="grid xl:grid-cols-12 xl:grid-rows-1 gap-6 xl:gap-15 xl:max-h-180">
        <CmsImage
          :cms-data-path="[...props.cmsDataPath, i, 'image_2']"
          class="rounded-3xl h-full object-cover w-full"
          :class="i % 2 == 0 ? 'xl:col-span-7' : 'xl:col-span-5'"
        />
        <CmsImage
          :cms-data-path="[...props.cmsDataPath, i, 'image_3']"
          class="rounded-3xl h-full object-cover w-full"
          :class="i % 2 == 0 ? 'xl:col-span-5' : 'xl:col-span-7'"
        />
      </div>
    </div>
    <div class="w-full flex items-center justify-center">
      <AppButton
        v-if="currentShowNumber < props.dataLength"
        button-theme="Transparent-Teksty"
        @click="ShowMore"
      >
        <span>Doładuj więcej</span>
      </AppButton>
    </div>
  </div>
</template>
